import { render } from "./cta.vue?vue&type=template&id=e129053a&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=e129053a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e129053a"

export default script